import styled from "styled-components";

export const Container = styled.div<{ $minimized?: boolean, $isOpenMenu?: boolean }>`
    position: absolute;
    bottom: 5px;
    /* left: 107px; */
    left: ${({ $isOpenMenu }) => ($isOpenMenu ? "545px" : "107px")};
    background: white;
    border-radius: 8px;
    padding: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    z-index: 100;
    min-width: ${({ $minimized }) => ($minimized ? "auto" : "200px")};
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
`;

export const Title = styled.div`
    font-size: 12px;
    font-weight: 600;
    color: #1e293b;
    display: flex;
    align-items: center;
    gap: 6px;

    svg {
        font-size: 16px;
        color: #64748b;
    }
`;

export const ToggleButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    padding: 4px;
    border-radius: 4px;
    color: #64748b;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
        font-size: 18px;
    }

    &:hover {
        background: #f1f5f9;
        color: #2196f3;
    }
`;

export const Content = styled.div<{ $collapsed?: boolean }>`
    display: ${({ $collapsed }) => ($collapsed ? "none" : "block")};
`;

export const LegendItem = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 10px;
    padding: 8px;
    border-radius: 4px;
    background: #f8fafc;

    &:last-child {
        margin-bottom: 0;
    }
`;

const legendColorVariants = {
    green: "#006400",
    red: "#FF0000",
    neutral: "#94a3b8",
} as const;

export const LegendColor = styled.div<{ $variant: keyof typeof legendColorVariants }>`
    width: 24px;
    height: 24px;
    border-radius: 3px;
    flex-shrink: 0;
    background: ${({ $variant }) => legendColorVariants[$variant]};
`;

export const LegendInfo = styled.div`
    flex: 1;
`;

export const LegendLabel = styled.div`
    font-size: 11px;
    font-weight: 600;
    color: #1e293b;
    margin-bottom: 2px;
`;

export const LegendStatsDetail = styled.div`
    font-size: 10px;
    color: #64748b;
`;
